module.exports = __webpack_public_path__ + "static/media/CircularStd-Bold.6f4fe3ca.woff";